<template>
    <div class="right_box_main">
        <!-- 面包屑导航 -->
        <div class="mianbao">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/griddingindex' }"
                    >网格工作</el-breadcrumb-item
                >
                <el-breadcrumb-item>社区议事协商</el-breadcrumb-item>
                <el-breadcrumb-item>数据字典</el-breadcrumb-item>
                <el-breadcrumb-item>政策法规</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-box">
            <!-- 右边卡片 -->
            <div class="card-rb">
                <div class="card-4">
                    <el-card :body-style="{ padding: '16px' }">
                        <div class="fisthang">
                            <el-form
                                :inline="true"
                                :model="searchlist"
                                class="demo-form-inline"
                                size="mini"
                            >
                                <el-form-item label="标题:">
                                    <el-input
                                        v-model="searchlist.title"
                                        placeholder="请输入"
                                        style="width: 130px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                        type="primary"
                                        @click="searchlistdata"
                                        >查询</el-button
                                    >
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                        type="info"
                                        @click="searchlistReset"
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="three">
                            <el-button
                                type="primary"
                                size="mini"
                                @click="showDialogForm()"
                                >新增</el-button
                            >
                            <!-- <el-button type="danger" size="mini">导出Excel</el-button> -->
                        </div>
                        <!-- 表格盒子 -->
                        <div class="table_card">
                            <el-table
                                :data="tableData"
                                :header-cell-style="{ background: '#f8fafa' }"
                                border
                                size="mini"
                                align="center"
                                current-row-key
                                highlight-current-row
                            >
                                <!-- <el-table-column type="selection" align="center" width="100px"></el-table-column> -->
                                <el-table-column
                                    type="index"
                                    align="center"
                                    label="序号"
                                    width="50"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="title"
                                    label="标题"
                                    width="300px"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="content"
                                    label="内容"
                                ></el-table-column>

                                <el-table-column
                                    align="center"
                                    label="操作"
                                    width="160px"
                                    fixed="right"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="查看"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-chakan tabBtn"
                                                @click="
                                                    showDialogFormLook(
                                                        scope.row.id
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="编辑"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-bianji3 tabBtn"
                                                @click="
                                                    showDialogForm(scope.row.id)
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="删除"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-icon7 tabBtn"
                                                @click="
                                                    showdeletepanduan(
                                                        scope.row.id
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 分页功能 -->
                            <el-pagination
                                :page-size="10"
                                layout="total, prev, pager, next, jumper"
                                @current-change="handleCurrentChange"
                                :total="pageConfig.total"
                            ></el-pagination>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
        <!-- 弹出框新增 -->
        <el-dialog :title="dialogTitle" :visible.sync="showadd" width="700px">
            <el-form
                ref="addform"
                :model="addform"
                :rules="rules"
                label-width="110px"
                size="mini"
            >
                <el-form-item label="标题：" prop="title">
                    <el-input
                        v-model="addform.title"
                        style="width: 500px"
                        :disabled="readyOnly"
                    ></el-input>
                </el-form-item>
                <el-form-item label="内容：">
                    <el-input
                        type="textarea"
                        v-model="addform.content"
                        style="width: 500px"
                        :disabled="readyOnly"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="boontbtn" v-if="addshow">
                <el-button
                    type="primary"
                    rows="4"
                    size="small"
                    style="margin: 0 30px"
                    @click="saveadddata"
                    >保存</el-button
                >
                <el-button type="info" size="small" @click="clearadddata"
                    >取消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "../../../utils/request.js"
let token = JSON.parse(window.localStorage.getItem("user"))
// import {
//   getSjzdList,
//   insertSjzdList,
//   deleteSjzdList,
//   findSjzdListById
// } from "@/api/api";
export default {
    data() {
        return {
            readyOnly: false,
            dialogTitle: "新增",
            filterText: "",
            searchlist: {},
            //  树形控件
            treedata: [],
            // 树形控件的配置
            defaultProps: {
                children: "children",
                label: "consultName",
            },
            //表格数据
            tableData: [],
            // 分页配置
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            // 新增弹出层
            showadd: false,
            addform: {},
            id: "",
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
            },
            addshow: true,
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val)
        },
        showadd(val) {
            if (!val) {
                this.readyOnly = false
                this.$refs["addform"].resetFields()
            }
        },
    },
    methods: {
        //树形列表

        //条件查询
        searchlistdata() {
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        searchlistReset() {
            this.searchlist = {}
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getPageDatas()
        },
        //获取列表数据
        async getPageDatas() {
            getSjzdList({
                ...this.pageConfig,
                ...this.searchlist,
            }).then((res) => {
                this.tableData = res.content.list
            })
        },

        // 取消
        clearadddata() {
            this.showadd = false
        },

        showDialogFormLook(id) {
            this.showadd = true
            this.readyOnly = true
            this.addshow = false
            let data = {}
            data.id = id
            findSjzdListById(data).then((res) => {
                this.addform = res.content
            })
        },
        //新增框 带着父类id
        async showDialogForm(id) {
            //编辑
            if (id > 0) {
                this.addshow = true
                this.showadd = true
                let data = {}
                data.id = id
                this.id = id
                findSjzdListById(data).then((res) => {
                    this.addform = res.content
                })
            } else {
                this.id = ""
                this.addshow = true
                this.showadd = true
                this.dialogTitle = "新增"
                this.addform = {}
            }
        },
        //获取新增所有数据发请求
        saveadddata() {
            if (this.id > 0) {
                insertSjzdList({
                    ...this.addform,
                    id: this.id,
                }).then((res) => {
                    this.$message.success(res.message)
                    this.showadd = false
                    this.getPageDatas()
                })
            } else {
                insertSjzdList({
                    ...this.addform,
                }).then((res) => {
                    this.$message.success(res.message)
                    this.showadd = false
                    this.getPageDatas()
                })
            }
        },
        //删除操作
        async showdeletepanduan(id) {
            this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let data = {}
                    data.id = id
                    deleteSjzdList(data).then((res) => {
                        this.$message.success(res.message)
                        this.getPageDatas()
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
    },
    mounted() {
        this.getPageDatas()
    },
}
</script>

<style lang="less" scoped>
.filter-tree .el-input__inner {
    height: 30px;
    line-height: 30px;
}
//  包裹两个卡片的盒子
.card-box {
    display: flex;
    // 左边树状列表卡片
    .card-l {
        margin-left: 10px;
        width: 300px;
        overflow-x: auto;
    }
    // 右边卡片
    .card-rb {
        //width: calc(100%);
        width: 100%;
    }
}
// 表格的盒子
.table_card {
    // overflow: hidden;
    // 解决表格无法自适应宽度
    // width: calc(100vw - 500px);
    margin: 16px 0 0 0;
    .el-table {
        width: 100%;
        // 表格里的按钮
        .tabBtn {
            margin: 0 6px;
        }
        .tabBtn:nth-child(1) {
            color: #199b5d;
        }
        .tabBtn:nth-child(2) {
            color: #a1a1a1;
        }
        .tabBtn:nth-child(3) {
            color: #dd3020;
        }
        .tabBtn:nth-child(4) {
            color: #2e99cf;
        }
        .active_Btn {
            color: #ff04ed !important;
        }
    }
}
</style>
